import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { useSyncStatus } from "../lib/sync";

export function SyncPill() {
  const { t } = useI18n();
  const s = useSyncStatus();
  const navigate = useNavigate();
  let cls = "bg-emerald-500/15 text-emerald-300";
  let label = t("sync.synced");
  if (s.syncing) {
    cls = "bg-gold/15 text-gold";
    label = t("sync.syncing");
  } else if (!s.online) {
    cls = "bg-brand/20 text-brand";
    label = t("sync.offlinePending", { n: s.pending });
  } else if (s.pending || s.dead) {
    cls = "bg-gold/15 text-gold";
    label = t("sync.pendingShort", { n: s.pending + s.dead });
  }
  return (
    <button
      onClick={() => navigate("/app/sync-issues")}
      className={`text-[10px] font-bold px-2.5 py-1 rounded-full whitespace-nowrap transition-colors ${cls}`}
      data-testid="sync-pill"
    >
      {s.syncing && <span className="inline-block animate-spin mr-1">⟳</span>}
      {!s.syncing && s.online && !s.pending && !s.dead && "● "}
      {!s.online && "◌ "}
      {label}
    </button>
  );
}

export function RequireOnline({ children }) {
  const { t } = useI18n();
  const s = useSyncStatus();
  if (s.online) return children;
  return (
    <div className="rounded-2xl bg-surface border border-line p-8 text-center mt-6" data-testid="offline-notice">
      <p className="text-3xl mb-3">📡</p>
      <p className="text-sm text-ink/75">{t("sync.needsConnection")}</p>
    </div>
  );
}

export function OfflineInline() {
  const { t } = useI18n();
  return (
    <p className="text-xs text-brand-ink bg-brand/10 rounded-xl px-3 py-2" data-testid="offline-inline-notice">
      📡 {t("sync.needsConnection")}
    </p>
  );
}
